import { FC, ReactNode, useRef } from 'react';
import { SnackbarProvider } from 'notistack';
import { CheckIconV2, InfoIconV2 } from '@setvi/shared/components/sicons';

import { SNACKBAR_DURATIONS, iconStyle } from './constants';
import { CustomSnackbarContent } from './CustomSnackbarContent';

// Extend notistack types to include details
declare module 'notistack' {
  interface OptionsObject {
    details?: any;
  }
}

interface CustomSnackbarProviderProps {
  children: ReactNode;
}

const CustomSnackbarProvider: FC<CustomSnackbarProviderProps> = ({
  children
}) => {
  const notistackRef = useRef<SnackbarProvider>();

  return (
    <SnackbarProvider
      ref={notistackRef}
      maxSnack={3}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      autoHideDuration={SNACKBAR_DURATIONS.default}
      iconVariant={{
        info: <InfoIconV2 fontSize="small" fill="white" style={iconStyle} />,
        warning: <InfoIconV2 fontSize="small" fill="white" style={iconStyle} />,
        success: (
          <CheckIconV2 fontSize="small" fill="white" style={iconStyle} />
        ),
        error: (
          <InfoIconV2
            fill="white"
            fontSize="small"
            style={{
              transform: 'rotate(180deg)',
              ...iconStyle
            }}
          />
        )
      }}
      Components={{
        info: CustomSnackbarContent,
        success: CustomSnackbarContent,
        warning: CustomSnackbarContent,
        error: CustomSnackbarContent
      }}>
      {children}
    </SnackbarProvider>
  );
};

export { SNACKBAR_DURATIONS } from './constants';
export default CustomSnackbarProvider;
